import React, { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const Hemograma = () => {
  const [formData, setFormData] = useState({
    hemoglobina: '',
    hematocrito: '',
    plaquetas: '',
    leucocitos: '',
    nomePaciente: '',
    dataNascimentoPaciente: '',
    cpfPaciente: '',
    sexoPaciente: '',
    nomeMedico: '',
    crmMedico: '',
    ufCrm: '',
    codigoTUSS: '',
    cid: '',
    unidadeAtendimento: '',
    convenio: '',
  });

  const [loading, setLoading] = useState(false);
  const db = getFirestore();
  const auth = getAuth();

  const fetchData = async () => {
    setLoading(true);
    try {
      const user = auth.currentUser;
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          setFormData((prevData) => ({
            ...prevData,
            nomePaciente: userData.nomePaciente || '',
            dataNascimentoPaciente: userData.dataNascimentoPaciente || '',
            cpfPaciente: userData.cpfPaciente || '',
            sexoPaciente: userData.sexoPaciente || '',
            nomeMedico: userData.nomeMedico || '',
            crmMedico: userData.crmMedico || '',
            ufCrm: userData.ufCrm || '',
            unidadeAtendimento: userData.unidadeAtendimento || '',
          }));
        } else {
          console.log('Nenhum dado encontrado');
        }
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulário de Hemograma submetido com os dados:', formData);
  };

  const convenioPadrao = {
    unimed: {
      formato: 'Padrão Unimed',
    },
    bradesco: {
      formato: 'Padrão Bradesco',
    },
    amil: {
      formato: 'Padrão Amil',
    },
  };

  if (loading) {
    return <p>Carregando...</p>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-2xl font-semibold mb-4">Gerar Laudo de Hemograma</h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Nome do Paciente:
            </label>
            <input
              type="text"
              name="nomePaciente"
              value={formData.nomePaciente}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Data de Nascimento:
            </label>
            <input
              type="date"
              name="dataNascimentoPaciente"
              value={formData.dataNascimentoPaciente}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              CPF ou CNS:
            </label>
            <input
              type="text"
              name="cpfPaciente"
              value={formData.cpfPaciente}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Sexo:
            </label>
            <select
              name="sexoPaciente"
              value={formData.sexoPaciente}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            >
              <option value="">Selecione o sexo</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Nome do Médico:
            </label>
            <input
              type="text"
              name="nomeMedico"
              value={formData.nomeMedico}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              CRM:
            </label>
            <input
              type="text"
              name="crmMedico"
              value={formData.crmMedico}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              UF do CRM:
            </label>
            <input
              type="text"
              name="ufCrm"
              value={formData.ufCrm}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Código TUSS:
            </label>
            <input
              type="text"
              name="codigoTUSS"
              value={formData.codigoTUSS}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              CID-10 (Diagnóstico):
            </label>
            <input
              type="text"
              name="cid"
              value={formData.cid}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Unidade de Atendimento:
            </label>
            <input
              type="text"
              name="unidadeAtendimento"
              value={formData.unidadeAtendimento}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Convênio:
            </label>
            <select
              name="convenio"
              value={formData.convenio}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
              required
            >
              <option value="">Selecione um convênio</option>
              <option value="unimed">Unimed</option>
              <option value="bradesco">Bradesco Saúde</option>
              <option value="amil">Amil</option>
            </select>
          </div>
        </div>

        <button
          type="submit"
          className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        >
          Gerar Laudo
        </button>
      </form>

      {formData.convenio && (
        <div className="mt-6">
          <p className="text-sm text-gray-700">
            Formato do convênio selecionado:{' '}
            {convenioPadrao[formData.convenio].formato}
          </p>
        </div>
      )}
    </div>
  );
};

export default Hemograma;
